/**
 * Mimesa's on-screen words. Mimesa calls the `promotor` role "Mercaderista" and uses neutral
 * "marca propia" wording where Mary names its brands. Only display text changes: role values,
 * API fields, routes and permission keys keep `promotor` / `promoters`.
 *
 * A key left out here falls back to Mary's (company/labels.js), and a test checks that every
 * key Mary defines is either here or deliberately shared.
 */
const MIMESA_LABELS = Object.freeze({
    promotor: 'Mercaderista',
    promotores: 'Mercaderistas',
    promotorLower: 'mercaderista',
    promotoresLower: 'mercaderistas',
    ownBrand: 'Marca propia',
    ownBrandFaces: 'Caras marca propia',
    ownBrandFacesPercent: 'Porcentaje caras marca propia',
    ownBrandProduct: 'producto de marca propia',
    navDistributorPrices: 'Levantamiento marca propia',
    navPolls: 'Encuestas',
    pollsTitle: 'Encuestas',
    pollsDescription: 'Resultados de las encuestas de Trade Marketing',
    navPollsDescription: 'Encuestas de Trade Marketing',
    permissionsScopeNote: 'Los permisos definen qué pantallas y funciones tiene cada rol.',
});

export default MIMESA_LABELS;
